const esc = (v) => String(v ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

export function printReportCard(r, schoolName = 'Sunrise Public School', logoUrl = null) {
  const rows = (r.rows || []).map((x) =>
    `<tr><td>${esc(x.subject)}</td><td>${esc(x.avg_pct)}%</td><td class="grade">${esc(x.grade)}</td><td>${esc(x.points)}</td></tr>`).join('');
  const logoTag = logoUrl ? `<img src="${esc(logoUrl)}" alt="" style="height:44px;object-fit:contain;margin-bottom:8px" />` : '';
  const html = `<!DOCTYPE html><html><head><title>Report Card - ${esc(r.student_name)}</title>
<style>
  @page { margin: 24mm; }
  body { font-family: Georgia, 'Times New Roman', serif; color: #0F172A; max-width: 640px; margin: 0 auto; }
  .head { text-align: center; border-bottom: 3px double #0F172A; padding-bottom: 16px; margin-bottom: 24px; }
  .head h1 { margin: 0; font-size: 26px; letter-spacing: 0.5px; }
  .head p { margin: 4px 0 0; font-size: 13px; color: #475569; }
  .meta { display: flex; justify-content: space-between; font-size: 14px; margin-bottom: 20px; }
  table { width: 100%; border-collapse: collapse; font-size: 14px; }
  th, td { border: 1px solid #94A3B8; padding: 8px 12px; text-align: left; }
  th { background: #F1F5F9; font-size: 12px; text-transform: uppercase; letter-spacing: 0.08em; }
  .grade { font-weight: bold; }
  .overall { margin-top: 20px; font-size: 16px; display: flex; justify-content: space-between; border-top: 2px solid #0F172A; padding-top: 12px; }
  .sig { margin-top: 60px; display: flex; justify-content: space-between; font-size: 12px; color: #475569; }
  .sig div { border-top: 1px solid #94A3B8; padding-top: 6px; width: 180px; text-align: center; }
  .foot { margin-top: 32px; font-size: 10px; color: #94A3B8; text-align: center; }
</style></head><body onload="setTimeout(function(){window.print()},300)">
  <div class="head">${logoTag}<h1>${esc(schoolName)}</h1><p>Academic Report Card · ${esc(r.term)} · ${r.generated_at ? esc(r.generated_at.slice(0, 10)) : ''}</p></div>
  <div class="meta">
    <span><b>Student:</b> ${esc(r.student_name)}</span>
    <span><b>Class:</b> Grade ${esc(r.grade)}${esc(r.section)}</span>
  </div>
  <table><thead><tr><th>Subject</th><th>Average</th><th>Grade</th><th>Points</th></tr></thead><tbody>${rows}</tbody></table>
  <div class="overall"><span>Overall</span><b>${esc(r.overall_pct)}%</b></div>
  <div class="sig"><div>Class Teacher</div><div>Principal</div><div>Guardian</div></div>
  <div class="foot">Generated by ONRID · Status: ${esc(r.status)} · Released report cards are tamper-evident and audited</div>
</body></html>`;
  const url = URL.createObjectURL(new Blob([html], { type: 'text/html' }));
  const w = window.open(url, '_blank', 'width=820,height=980');
  if (!w) { URL.revokeObjectURL(url); return; }
  setTimeout(() => URL.revokeObjectURL(url), 60000);
}
